
import { useQuery } from '@tanstack/react-query'
import { MdOutlineFolderShared } from 'react-icons/md'
import { Link, useNavigate } from 'react-router-dom'

import http from '../../../../lib/http'
import { useAppSelector } from '../../../../store'
import * as Table from '../../../claim-history/simple-table'
import { NoDataPlaceHolder } from '../../../PatientFolder/behavioral/components'
import { ContextMenuButton } from '../../../shared/ContextMenu'
import * as Sidebar from '../components/index'
import styles from '../patient-search/patient-search.module.css'

interface Patient {
  id: string
  firstName: string
  lastName: string
  client: string
}

export function RecentPatients (): JSX.Element {
  const navigate = useNavigate()
  const { clients } = useAppSelector(state => state.globalVars)
  let query = useQuery<unknown, unknown, Patient[], [string]>({
    queryKey: [ 'recent-patients' ],

    async queryFn () {
      const params = new URLSearchParams()

      params.set('limit', '30')

      return await http.getRequest('/recent-patients', params)
    }
  })

  return (
    <>
      <Sidebar.Header>Recent Patients</Sidebar.Header>
      <Sidebar.Wrapper>
        {(query?.data?.length ?? 0) <= 0 && query.isFetched && (
          <NoDataPlaceHolder
            title='There are no Recent Patients to display'
            className='bg-transparent'
          />
        )}
        <Table.ContainerMeasureProvider>
          <Sidebar.Cards>
            {query.data?.map(({ firstName, lastName, id, client }) => (
              <Sidebar.Card key={id}>
                <Link
                  title='Open Patient Folder'
                  style={{
                    flex: 1,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                  to={`/patient/${client}/${id}`}
                >
                  <p className={styles.patientName}>
                    {firstName} {lastName}
                  </p>
                  <p style={{ color: '#857E90' }}>{clients?.find((_client) => _client.clientName === client)?.display}</p>
                </Link>
                <ContextMenuButton
                  actions={[
                    {
                      id: 'patient-holder',
                      icon: MdOutlineFolderShared,
                      label: 'Patient Folder',
                      onClick: () => {
                        navigate(`/patient/${client}/${id}`)
                      }
                    }
                  ]}
                  onClose={() => ({})}
                />
              </Sidebar.Card>

            ))}
          </Sidebar.Cards>
        </Table.ContainerMeasureProvider>
      </Sidebar.Wrapper>
    </>
  )
}
